module.exports = {
	"name": "TunAd",
	"supportEmail": "tunad@tunad.io",
	"tenant": "https://oauth.tunad.io",
	"apiLink": "https://api.tunad.io",
	"logoUrl": "https://tunad.io/wp-content/themes/tunad/favicon.png",
	"apiIdentifier": "https://api.tunad.io",
	"apiDocLink": "https://api.tunad.io"
};


//////////////////
// WEBPACK FOOTER
// ./settings.json
// module id = 38
// module chunks = 0